import React from 'react';

const colorMap: Record<string, string> = {
  succeeded: '#22c55e',
  syncing: '#3b82f6',
  queued: '#f59e0b',
  failed: '#ef4444',
  idle: '#9ca3af',
  processing: '#3b82f6',
};

export default function StatusBadge({ status }: { status: string }) {
  const color = colorMap[status] || '#9ca3af';
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: '12px',
      fontSize: '11px',
      fontWeight: 600,
      color: '#fff',
      background: color,
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
    }}>
      {status}
    </span>
  );
}
